document.addEventListener('DOMContentLoaded', () => {
  gsap.registerPlugin(ScrollTrigger);

  const section = document.querySelector('#momentum-scroll');
  if (section) {
    const items = gsap.utils.toArray('.momentum-item');
    const imgs = gsap.utils.toArray('.momentum-img-wrapper');
    const colors = ["#83BB89", "#5B90B3", "#CF92A5", "#E5CB84"];

    let mainTl = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: "top top",
        end: "+=500%", // Longer scroll for 4 flavors
        pin: true,     
        scrub: 1,      
        anticipatePin: 1
      }
    });

    // Initial State
    gsap.set(items[0], { autoAlpha: 1, y: 0 });
    gsap.set(imgs[0], { autoAlpha: 1, scale: 1 });

    // --- TRANSITION 1: Kiwi to Blue Raspberry ---
    mainTl.to({}, { duration: 2 }) // Static Hold
      .addLabel("swap1")
      .to(section, { backgroundColor: colors[1], duration: 1 }, "swap1")
      .to(items[0], { autoAlpha: 0, y: -50, duration: 1 }, "swap1")
      .to(imgs[0], { autoAlpha: 0, scale: 0.7, duration: 1 }, "swap1")
      .fromTo(items[1], { autoAlpha: 0, y: 50 }, { autoAlpha: 1, y: 0, duration: 1 }, "swap1")
      .fromTo(imgs[1], { autoAlpha: 0, scale: 1.3 }, { autoAlpha: 1, scale: 1, duration: 1 }, "swap1");

    // --- TRANSITION 2: Blue Raspberry to Strawberry Lemonade ---
    mainTl.to({}, { duration: 2 }) // Static Hold
      .addLabel("swap2")
      .to(section, { backgroundColor: colors[2], duration: 1 }, "swap2")
      .to(items[1], { autoAlpha: 0, y: -50, duration: 1 }, "swap2")
      .to(imgs[1], { autoAlpha: 0, scale: 0.7, duration: 1 }, "swap2")
      .fromTo(items[2], { autoAlpha: 0, y: 50 }, { autoAlpha: 1, y: 0, duration: 1 }, "swap2")
      .fromTo(imgs[2], { autoAlpha: 0, scale: 1.3 }, { autoAlpha: 1, scale: 1, duration: 1 }, "swap2");

    // --- TRANSITION 3: Strawberry Lemonade to Pina Colada ---
    mainTl.to({}, { duration: 2 }) // Static Hold
      .addLabel("swap3")
      .to(section, { backgroundColor: colors[3], duration: 1 }, "swap3")
      .to(items[2], { autoAlpha: 0, y: -50, duration: 1 }, "swap3")
      .to(imgs[2], { autoAlpha: 0, scale: 0.7, duration: 1 }, "swap3")
      .fromTo(items[3], { autoAlpha: 0, y: 50 }, { autoAlpha: 1, y: 0, duration: 1 }, "swap3")
      .fromTo(imgs[3], { autoAlpha: 0, scale: 1.3 }, { autoAlpha: 1, scale: 1, duration: 1 }, "swap3");

    mainTl.to({}, { duration: 2 }); // Final Hold
  }

  // SNAPPY REVEALS FOR PRODUCT CARDS
  gsap.utils.toArray('.grid__item, .product-card').forEach(card => {
    gsap.from(card, {
      scrollTrigger: {
        trigger: card,
        start: "top 95%",
        toggleActions: "play none none reverse"
      },
      opacity: 0,
      y: 20,
      duration: 0.6,
      ease: "power2.out"
    });
  });
});